"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTION_LAYOUT_TYPE = void 0;
exports.SECTION_LAYOUT_TYPE = {
    ONE_COLUMN: 1,
    TWO_COLUMN: 2,
    THREE_COLUMN: 3,
    ONE_COLUMN_80: 4,
    ONE_COLUMN_60: 5,
    ONE_COLUMN_40: 6,
    ONE_COLUMN_OVERFLOW_AREA: 7,
    TWO_COLUMN_L_50_2A_R_50_1A: 8,
    TWO_COLUMN_L_50_3A_R_50_1A: 9,
    TWO_COLUMN_L_40_1A_R_60_1A: 10,
    TWO_COLUMN_L_67_1A_R_33_1A: 11,
    TWO_COLUMN_L_67_2A_R_33_1A: 12,
    TWO_COLUMN_L_80_1A_R_20_1A: 13,
    TWO_ROW_T_80_1A_B_20_1A: 14,
    TWO_ROW_T_60_1A_B_40_1A: 15,
    TWO_ROW_T_20_1A_B_80_1A: 16,
    TWO_ROW_T_50_2A_B_50_1A: 17,
    TWO_ROW_T_50_1A_B_50_2A: 18,
    TWO_COLUMN_TWO_ROW_50_2A_50_2A: 19,
    TWO_COLUMN_TWO_ROW_67_2A_33_2A: 20,
    THREE_COLUMN_TWO_ROW: 21,
};
